export default {"src":"/_next/static/image/public/images/icons2/3.d47073c5af0b3bb7f63ed2279de2e834.svg","height":24,"width":24};